import React from 'react'

function UploadIcon() {
  return (
    <svg
      width="23"
      height="17"
      viewBox="0 0 23 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.22982 16.1663C4.77635 16.1663 3.53451 15.6632 2.5043 14.657C1.47409 13.6507 0.958984 12.4209 0.958984 10.9674C0.958984 9.72155 1.33433 8.61148 2.08503 7.63717C2.83572 6.66287 3.81801 6.03995 5.0319 5.76842C5.43121 4.29898 6.22982 3.10905 7.42773 2.19863C8.62565 1.28822 9.98329 0.833008 11.5007 0.833008C13.3694 0.833008 14.9546 1.48388 16.2564 2.78561C17.5581 4.08735 18.209 5.67259 18.209 7.54134C19.3111 7.66912 20.2255 8.14429 20.9522 8.96686C21.679 9.78943 22.0423 10.7518 22.0423 11.8538C22.0423 13.0518 21.623 14.07 20.7845 14.9085C19.946 15.7471 18.9277 16.1663 17.7298 16.1663H12.459C11.9319 16.1663 11.4807 15.9787 11.1053 15.6033C10.73 15.228 10.5423 14.7768 10.5423 14.2497V9.31426L9.00899 10.7997L7.66732 9.45801L11.5007 5.62467L15.334 9.45801L13.9923 10.7997L12.459 9.31426V14.2497H17.7298C18.4007 14.2497 18.9677 14.0181 19.4309 13.5549C19.8941 13.0917 20.1257 12.5247 20.1257 11.8538C20.1257 11.183 19.8941 10.616 19.4309 10.1528C18.9677 9.6896 18.4007 9.45801 17.7298 9.45801H16.2923V7.54134C16.2923 6.21565 15.8251 5.08561 14.8908 4.15124C13.9564 3.21686 12.8263 2.74967 11.5007 2.74967C10.175 2.74967 9.04492 3.21686 8.11055 4.15124C7.17617 5.08561 6.70898 6.21565 6.70898 7.54134H6.22982C5.30343 7.54134 4.5128 7.86877 3.85794 8.52363C3.20308 9.17849 2.87565 9.96912 2.87565 10.8955C2.87565 11.8219 3.20308 12.6125 3.85794 13.2674C4.5128 13.9222 5.30343 14.2497 6.22982 14.2497H8.62565V16.1663H6.22982Z"
        fill="#4A4A4A"
      />
    </svg>
  )
}

export default UploadIcon
